import axios from '@/plugins/axios'
import * as typesAPI from '@/models/api/models-api'
import { backendAPIConfig } from '@baseConfig'
import { StringHelper } from '@/helpers/string'
import { HttpStatus } from '@/models/converter/convert'
import { GetMembersCardRequest } from '@/models/api/members-card'

export class MembersCardApi {
    /**
     * Web-LINE会員証取得
     * @public
     * @async
     * @param {GetMembersCardRequest} request
     * @returns {typesAPI.APIResponse}
     */
    async getMembersCard(request) {
        let res = {}
        if (request.mock) {
            res = {
                "data": {
                    "result": "success",
                    "data": {
                        "card_number": "0000007518416",
                        "is_mypage_linked": false
                    },
                },
                "status": 200,
            }
        } else {
            res = await axios.get(`${backendAPIConfig.endpoint}/web/members-card`, {
                params: {
                    provision_shop_code: request.provisionShopCode,
                    lineid: request.lineid,
                    brandsite: request.brandsite,
                }
            })
        }
        return res
    }
}
